import React, { FC } from 'react';
import PresenceActiveIcon from '@atlaskit/icon/glyph/presence-active';
import PresenceUnavailableIcon from '@atlaskit/icon/glyph/presence-unavailable';
import { ButtonItem } from '@atlaskit/menu';
import styled from 'styled-components';

import { TempoAtras } from 'view/component/Tempo/TempoAtras';
import { Negrito, TextoPequeno } from 'view/component/Tipografia/Texto';

import { BotaoClean } from 'view/component/Botao/Botao';
import { ItemListaNotificacoes } from './model/ItemListaNotificacoes';

export interface NotificacaoItemPropsGeral {
  /**
   * Evento disparado quando o item é selecionado
   */
  onItemClick: (notificacao: ItemListaNotificacoes) => void
}

export interface NotificacaoItemPropsEventos extends NotificacaoItemPropsGeral {
  /**
   * Evento disparado quando alguém clica nos botões "Marcar como lida" ou "Marcar como não lida"
   * Quem é chamado pelo evento que deve alterar o objeto `ItemListaNotificacoes`
   */
  onVisualizadoToggle: (notificacao: ItemListaNotificacoes) => void
}


interface NotificacaoItemProps extends NotificacaoItemPropsEventos {
  /**
   * Número máximo de caracteres exibidos na mensagem de notificação
   * 
   * Se o número ultrapassar a `título + mensagem + 3 caracteres`, a mensagem é cortada até que a soma
   * de `título + mensagem + 3 caracteres = maximoCaracteres`. 
   */
  maximoCaracteres?: number;
  /**
   * Notificação a ser exibida no item
   */
  notificacao: ItemListaNotificacoes
}

export const NotificacaoItem: FC<NotificacaoItemProps> = ({notificacao, onItemClick, maximoCaracteres=150, onVisualizadoToggle: onVisualizadoToggled}) => {
  const titulo = notificacao.titulo;

  const tamanhoMensagem = maximoCaracteres > titulo.length - 3 
    ? maximoCaracteres - titulo.length - 3 
    : 0;
  
    const mensagem = notificacao.mensagem.slice(0, tamanhoMensagem);

  const onToggle = () => onVisualizadoToggled(notificacao)
  return <ButtonItem 
    onClick={() => onItemClick(notificacao)}
    iconAfter={<NotificacaoItemStatus onVisualizadoToggled={onToggle} visualizado={notificacao.visualizado} />}
    >
      <NotificacaoItemConteudo>
        <Negrito>{titulo} - </Negrito>
        {mensagem}
      </NotificacaoItemConteudo>
      <TextoPequeno>
        <NotificacaoItemData>
          <TempoAtras data={notificacao.dataNotificacao} style="narrow" />
        </NotificacaoItemData>
      </TextoPequeno>
  </ButtonItem>
}

const NotificacaoItemConteudo = styled.div`
  color: ${({theme}) => theme.texto.enfase_media};
  white-space: initial;
`;

const NotificacaoItemData = styled.div`
  color: ${({theme}) => theme.texto.enfase_baixa};
  padding-top: .2em;
`;

interface NotificacaoItemStatusProps {
  visualizado: boolean
  onVisualizadoToggled: () => void
}

const NotificacaoItemStatus: FC<NotificacaoItemStatusProps> = ({visualizado, onVisualizadoToggled}) => {
  const onBotaoVisualizadoClick = (event: any) => {
    // Não disparar evento de clicar no item
    event.stopPropagation();

    onVisualizadoToggled();
  }

  if (!visualizado) {
    return <BotaoClean onClick={onBotaoVisualizadoClick} title="Marcar como não lida">
      <PresenceActiveIcon label="Marcar como não lida"/>
    </BotaoClean>
  }

  return <BotaoClean onClick={onBotaoVisualizadoClick} title="Marcar como lida">
    <PresenceUnavailableIcon label="Marcar como lida"/>
  </BotaoClean>
}
